import Hero from './Hero.js';
import { Flex } from '@chakra-ui/react';
import ProjectsGallery from './ProjectsGallery.js';
import ScrollArrow from './utils/ScrollArrow/ScrollArrow.js';

function Home({ text }){
  return(
    <Flex direction='column' alignItems='center'>
      <ScrollArrow timeout={15000} />
      <Hero text={text.Hero} />
      <ProjectsGallery text={text.ProjectsGallery} />
    </Flex>
  );
}

export default Home;